
export const salesInvoiceData = {
  company: {
    name: "ABC Enterprises Pvt. Ltd.",
    address: "123 Business Street, Andheri East",
    city: "Mumbai",
    state: "Maharashtra",
    zip: "400093",
    phone: "+91-9876543210",
    fax: "+91-22-12345678",
    email: "info@abc-enterprises.com",
    website: "www.abc-enterprises.com",
  },
  invoiceNumber: "INV-20260115-001",
  date: "15-Jan-2026",
  customer: {
    id: "CUST-12345",
    name: "Ramesh Sharma",
    companyName: "Sharma Traders",
    address: "456 Market Road",
    city: "Pune",
    state: "Maharashtra",
    zip: "411001",
    phone: "+91-9123456789",
  },
  salesperson: "Rohit Sharma",
  poNumber: "PO-98765",
  shipDate: "18-Jan-2026",
  shipVia: "FedEx",
  fob: "Mumbai",
  terms: "Net 30",
  taxRate: 18, // in %
  sh: 50,      // shipping
  other: 25,   // other charges
  items: [
    { id: 1, desc: "Product A", qty: 5, rate: 200, amount: 1000 },
    { id: 2, desc: "Product B", qty: 2, rate: 450, amount: 900 },
    { id: 3, desc: "Product C", qty: 1, rate: 1500, amount: 1500 },
    { id: 4, desc: "Product D", qty: 3, rate: 600, amount: 1800 },
  ],
};
